import config from "../branding/default/js/config";

const initialState = {
  username: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  password: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
    dontmatch: null,
  },
  firstname: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  lastname: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  address: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  postcode: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  city: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  email: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  phonenumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  mobilenumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  textphonenumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  isdnnumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  gggnumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  faxnumber: {
    value: null,
    visible: false,
    required: false,
    regex: null,
    regexText: null,
  },
  changeUserInProgress: false,
  changeUserComplete: false,
  changeUserError: false,
  changeUserErrorText: null,
};

const changeUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_REFRESH":
    case "USER_LOGIN_SUCCESS":
      state = {
        ...state,
        username: {
          ...state.username,
          value: action.payload.user.properties.USERNAME,
        },
        password: {
          ...state.password,
          value: null,
        },
        firstname: {
          ...state.firstname,
          value: action.payload.user.properties.FORENAME,
        },
        lastname: {
          ...state.lastname,
          value: action.payload.user.properties.SURNAME,
        },
        address: {
          ...state.address,
          value: action.payload.user.properties.ADDRESS,
        },
        postcode: {
          ...state.postcode,
          value: action.payload.user.properties.POSTCODE,
        },
        city: {
          ...state.city,
          value: action.payload.user.properties.CITY,
        },
        email: {
          ...state.email,
          value: action.payload.user.properties.EMAIL,
        },
        phonenumber: {
          ...state.phonenumber,
          value: action.payload.user.properties.PHONE_NUMBER,
        },
        mobilenumber: {
          ...state.mobilenumber,
          value: action.payload.user.properties.MOBILE_NUMBER,
        },
        textphonenumber: {
          ...state.textphonenumber,
          value: action.payload.user.properties.TEXT_PHONE_NUMBER,
        },
        isdnnumber: {
          ...state.isdnnumber,
          value: action.payload.user.properties.ISDN_NUMBER,
        },
        gggnumber: {
          ...state.gggnumber,
          value: action.payload.user.properties.GGG_NUMBER,
        },
        faxnumber: {
          ...state.faxnumber,
          value: action.payload.user.properties.FAX_NUMBER,
        },
      };
      break;
    case "CONFIG_SYSTEM_LOADED":
      state = {
        ...state,
        username: {
          ...state.username,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "username"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "username"
          ),
          regex: "^[a-z0-9\\-\\.]{5,100}$",
          regexText: action.payload.config.text("common.username_helptext"),
        },
        password: {
          ...state.password,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "password"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "password"
          ),
          regex: config.password.passwordregex,
          regexText: action.payload.config.text("common.password1_helptext"),
          dontmatch: action.payload.config.text("common.password2_helptext"),
        },
        firstname: {
          ...state.usefirstnamername,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "firstname"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "firstname"
          ),
        },
        lastname: {
          ...state.lastname,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "lastname"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "lastname"
          ),
        },
        address: {
          ...state.address,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "street address"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "street address"
          ),
        },
        postcode: {
          ...state.postcode,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "post code"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "post code"
          ),
        },
        city: {
          ...state.city,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "city"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "city"
          ),
        },
        email: {
          ...state.email,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "email address"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "email address"
          ),
          // eslint-disable-next-line
          regex: "[A-Za-z0-9._-]+@[A-Za-z0-9._-]+[.]{1}[A-Za-z]{2,4}$",
          regexText: action.payload.config.text("common.email_helptext"),
        },
        phonenumber: {
          ...state.phonenumber,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "phone number"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "phone number"
          ),
        },
        mobilenumber: {
          ...state.mobilenumber,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "mobile number"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "mobile number"
          ),
        },
        textphonenumber: {
          ...state.textphonenumber,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "textphone"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "textphone"
          ),
        },
        isdnnumber: {
          ...state.isdnnumber,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "isdn number"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "isdn number"
          ),
        },
        gggnumber: {
          ...state.gggnumber,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "3g number"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "3g number"
          ),
        },
        faxnumber: {
          ...state.faxnumber,
          visible: contains(
            action.payload.systemConfig.WEB_CHANGE_OWN_DATA_VISIBLE_FIELDS,
            "fax number"
          ),
          required: contains(
            action.payload.systemConfig.WEB_REQUIRED_FIELDS,
            "fax number"
          ),
        },
      };
      break;
    case "CHANGE_USER_INIT":
      state = {
        ...state,
        changeUserInProgress: true,
        changeUserComplete: false,
        changeUserError: false,
      };
      break;
    case "CHANGE_USER_SUCCESS":
      state = {
        ...state,
        changeUserInProgress: false,
        changeUserComplete: true,
        changeUserError: false,
      };
      break;
    case "CHANGE_USER_ERROR":
      state = {
        ...state,
        changeUserInProgress: false,
        changeUserComplete: false,
        changeUserError: true,
        changeUserErrorText: action.payload,
      };
      break;
    case "CHANGE_USER_CLEAR":
      state = {
        ...state,
        changeUserInProgress: false,
        changeUserComplete: false,
        changeUserError: false,
        changeUserErrorText: null,
      };
      break;
    default:
      break;
  }
  return state;
};

function contains(str, substr) {
  return str.indexOf(substr) !== -1;
}

export default changeUserReducer;






// WEBPACK FOOTER //
// ./src/reducers/changeUserReducer.js